import {
  ACTIVITY_STREAM_RECEIVE,
  ACTIVITY_STREAM_REQUEST,
  CLUB_VIDEO_REQUEST,
  CLUB_VIDEO_RECEIVE,
  CLUB_VIDEO_FAILURE,
  VIDEO_LIST_REQUEST,
  VIDEO_LIST_RECEIVE,
  VIDEO_LIST_FAILURE,
  PAGE_DATA_LOAD,
  VIDEO_WATCHED,
} from '../../action-types';
import PageDataLoader from '../../../lib/page-data/loader';
import PageKey from '../../../lib/page-data/key';

export const fetchVideoPageData = (clubId, videoId, request) => async (dispatch) => {
  try {
    dispatch({ type: CLUB_VIDEO_REQUEST, payload: { clubId, videoId } });
    const pageKey = new PageKey(clubId, 'video', { id: videoId });
    const pageData = await PageDataLoader.getPageData(pageKey, request);
    const { related, ...video } = pageData.data;
    dispatch({ type: CLUB_VIDEO_RECEIVE, payload: { videoId, video, related } });
    dispatch({
      type: ACTIVITY_STREAM_RECEIVE,
      payload: { clubId, messages: related, key: pageData.key.toString() },
    });
    dispatch({ type: PAGE_DATA_LOAD, payload: pageKey.toString() });
    return { accessLevel: pageData.accessLevel };
  } catch (error) {
    let statusCode = 500;
    if (error) {
      statusCode = error.errorStatusCode || statusCode;
    }

    dispatch({
      type: CLUB_VIDEO_FAILURE,
      payload: { clubId, videoId, statusCode, error },
    });
    return { error };
  }
};

export const fetchVideoListPageData =
  (clubId, teamId, page, search, request) => async (dispatch) => {
    try {
      dispatch({ type: VIDEO_LIST_REQUEST, payload: { clubId, teamId, page, search } });
      dispatch({ type: ACTIVITY_STREAM_REQUEST, payload: { clubId } });
      const pageKey = new PageKey(clubId, 'video_list', { teamId, page, search });
      const pageData = await PageDataLoader.getPageData(pageKey, request);
      const { videos, pagination } = pageData.data;
      dispatch({
        type: VIDEO_LIST_RECEIVE,
        payload: { clubId, teamId, page, videos, pagination, search },
      });

      dispatch({
        type: ACTIVITY_STREAM_RECEIVE,
        payload: { clubId, messages: videos, key: pageData.key.toString() },
      });
      dispatch({ type: PAGE_DATA_LOAD, payload: pageKey.toString() });

      return {};
    } catch (error) {
      let statusCode = 500;
      if (error) {
        statusCode = error.errorStatusCode || statusCode;
      }

      dispatch({
        type: VIDEO_LIST_FAILURE,
        payload: { clubId, teamId, page, search, statusCode, error },
      });
      return { error };
    }
  };

export const markVideoAsWatched = (videoId) => (dispatch) => {
  dispatch({ type: VIDEO_WATCHED, payload: { videoId } });
};
